<template>
    <b-container>
        <b-container fluid style="padding-top: 20px">
            <b-row>
                <b-col cols="2"/>
                <b-col cols="8" align="center"><h3>Editing Account: "{{ wineryName }}"</h3></b-col>
                <b-col cols="2"/>

            </b-row>
            <b-container fluid="md" v-if="displayWineryMenu">
              <b-card bg-variant="light">

                <b-form-group
                    label-cols-sm="4"
                    label="Business Name:"
                    label-align-sm="left"
                    label-for="nested-street"
                >
                  <b-form-input id="nested-company-name" size="sm" v-model="businessName"
                                placeholder="Business Name"/>
                    </b-form-group>

                    <b-form-group
                            label-cols="4"
                            label-size="md"
                            label="Business Address:"
                            label-align-sm="left"
                            label-for="nested-street"
                    >
                        <b-form-input id="nested-street" size="sm" v-model="businessAddress"
                                      placeholder="Business Address"/>
                    </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="County*:"
                    label-for="input-sm">
                  <b-form-select
                      v-model="county"
                      :options="countyMap">
                  </b-form-select>
                </b-form-group>

                <b-form-group
                        label-cols="4"
                        label-cols-lg="4"
                        label-size="md"
                        label="Contact Name*: (Someone familiar with the winery operation and facility)"
                        label-for="input-sm">
                      <b-form-select
                          v-model="primaryContactId"
                          :options="contactPersonMap"></b-form-select>
                    </b-form-group>

                    <b-form-group
                            label-cols="4"
                            label-cols-lg="4"
                            label-size="md"
                            label="Contact Phone Number*:"
                            label-for="input-sm">
                      <b-form-input id="contactTelephoneNumber" size="sm"
                                    :disabled=true v-model="computedTelephone" placeholder="Telephone"/>
                    </b-form-group>

                    <b-form-group
                            label-cols="4"
                            label-cols-lg="4"
                            label-size="md"
                            label="Email Address*:"
                            label-for="input-sm">
                      <b-form-input id="input-sm" size="sm" v-model="computedEmail"
                                    :disabled=true placeholder="Contact Email"/>
                    </b-form-group>
                ===
                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Accountant Name*: "
                    label-for="input-sm">
                  <b-form-input id="input-sm" size="sm" v-model="accountantName"
                                placeholder="Accountant Name"/>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Accountant Email Address*:"
                    label-for="input-sm">
                  <b-form-input id="input-sm" size="sm" v-model="accountantEmail"
                                placeholder="Accountant Email"/>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Communications/Marketing Contact:"
                    label-for="input-sm">
                  <b-form-input id="input-sm" size="sm" v-model="communicationsContact"
                                placeholder="Communications/Marketing Contact"/>
                </b-form-group>
                ====
                <b-form-group label="Alerts Enabled:" v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                      id="accountStatus"
                      v-model="alertsEnabled"
                      :options="statusOptions"
                      :unchecked-value="false"
                      stacked
                      :aria-describedby="ariaDescribedby"
                      name="accountStatus">
                  </b-form-radio-group>
                </b-form-group>

                    <b-form-group
                            label-cols="4"
                            label-cols-lg="4"
                            label-size="md"
                            label="Waste/Recycling/Compost Service Provider Name(s):"
                            label-for="input-sm">
                        <b-form-input id="input-sm" size="sm" v-model="wasteProvider"
                                      placeholder="Waste Provider"/>
                    </b-form-group>
                    <b-form-group
                            label-cols="4"
                            label-cols-lg="4"
                            label-size="md"
                            label="Water Supply Source: (Well/Municipal)"
                            label-for="input-sm">
                        <b-form-input id="input-sm" size="sm" v-model="waterSupplySource"
                                      placeholder="Water Supply Source"/>
                    </b-form-group>

                    <b-container fluid>

                        <b-form-group
                                label="Do you have a water meter that allows you to track process + offices + hospitality water use? (If no, we can assist with this).">
                            <b-form-radio-group
                                    v-model="trackableWaterMeter"
                                    :options="yesNoOptions"
                                    name="waterMeterTracking"
                                    stacked
                            />
                        </b-form-group>


                        <b-form-group
                                label="Have you had a PG&E/CLEAResult Wine Industry Efficiency Solutions (WIES) audit in the past 5 years?">
                            <b-form-radio-group
                                    v-model="wiesSelected"
                                    :options="yesNoOptions"
                                    name="clearResult   "
                                    stacked
                            />
                        </b-form-group>
                        <b-form-group label="Renewable Energy (Check those that apply):">
                            <b-form-checkbox-group
                                    v-model="renewableEnergySelected"
                                    :options="renewableEnergyOptions"
                                    name="renewableEnergyInstalled"
                                    stacked
                            />
                        </b-form-group>
                        <b-form-group label="EV Charging Station(s):">
                            <b-form-radio-group
                                    v-model="evChargingStations"
                                    :options="yesNoOptions"
                                    name="flavour-2a"
                                    stacked
                            />
                        </b-form-group>

                        <b-form-group label="Other Environmental Certification (check those that apply):">
                            <b-form-checkbox-group
                                    v-model="environmentalCertifications"
                                    :options="environmentalCertificationsOptions"
                                    name="environmentalCertifications"
                                    stacked
                            />
                        </b-form-group>
                        <b-form-group label="Please indicate if you have the following features:">
                            <b-form-checkbox-group
                                    v-model="featuresSelected"
                                    :options="featuresOptions"
                                    name="flavour-2a"
                                    stacked
                            />
                        </b-form-group>
                        <b-form-group label="Wastewater Treatment (Check relevant): ">
                            <b-form-checkbox-group
                                    v-model="wasteWaterSelected"
                                    :options="wasteWaterTreatmentOptions"
                                    name="flavour-2a"
                                    stacked
                            />
                        </b-form-group>
                    </b-container>

                    <b-container fluid>
                      <b-row align-h="center">
                        <b-col cols="2"/>
                        <b-col cols="8">*Questions marked with an asterisk must be completed to submit the
                          form.
                        </b-col>
                        <b-col cols="2"/>
                      </b-row>
                    </b-container>
              </b-card>
            </b-container>

          <b-container fluid="md" v-else>
            <b-container fluid="md">
              <b-card bg-variant="light">

                <b-form-group
                    label-cols-sm="4"
                    label="Company Name*:"
                    label-align-sm="left"
                    label-for="nested-street"
                >
                  <b-form-input id="name" size="sm" v-model="name"
                                placeholder="Company Name"/>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-size="md"
                    label="Company Mailing Address*:"
                    label-align-sm="left"
                    label-for="nested-street"
                >
                  <b-form-input id="address" size="sm" v-model="address"
                                placeholder="Company Address"/>
                </b-form-group>


                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="County*:"
                    label-for="input-sm">
                  <b-form-select
                      v-model="county"
                      :options="countyMap">
                  </b-form-select>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Contact Name (Vineyard Manager/Management Company)*:"
                    label-for="input-sm">
                  <b-form-select
                      v-model="primaryContactId"
                      :options="contactPersonMap"></b-form-select>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Contact Phone Number*:"
                    label-for="input-sm">
                  <b-form-input id="contactTelephoneNumber" size="sm"
                                :disabled=true v-model="computedTelephone" placeholder="Telephone"/>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Email Address*:"
                    label-for="input-sm">
                  <b-form-input id="input-sm" size="sm" v-model="computedEmail"
                                :disabled=true placeholder="Contact Email"/>
                </b-form-group>


                <b-form-group label="Alerts Enabled:" v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                      id="accountStatus"
                      v-model="alertsEnabled"
                      :options="statusOptions"
                      :unchecked-value="false"
                      stacked
                      :aria-describedby="ariaDescribedby"
                      name="accountStatus">
                  </b-form-radio-group>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Owner Name*: "
                    label-for="ownerName">
                  <b-form-input id="ownerName" size="sm" v-model="ownerName"
                                placeholder="Owner Name"/>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Owner Phone Number:"
                    label-for="ownerTelephoneNumber">
                  <b-form-input id="ownerTelephoneNumber" size="sm"
                                v-model="ownerTelephoneNumber" placeholder="Owner Telephone Number"/>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Owner Email Address*:"
                    label-for="ownerEmail">
                  <b-form-input id="ownerEmail" size="sm" v-model="ownerEmail"
                                placeholder="Owner Email"/>
                </b-form-group>

                ===
                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Accountant Name*: "
                    label-for="input-sm">
                  <b-form-input id="input-sm" size="sm" v-model="accountantName"
                                placeholder="Accountant Name"/>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Accountant Email Address*:"
                    label-for="input-sm">
                  <b-form-input id="input-sm" size="sm" v-model="accountantEmail"
                                placeholder="Accountant Email"/>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Communications/Marketing Contact:"
                    label-for="input-sm">
                  <b-form-input id="input-sm" size="sm" v-model="communicationsContact"
                                placeholder="Communications/Marketing Contact"/>
                </b-form-group>
                ====

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Vineyard Name(s):"
                    label-for="vineyardNames">
                  <b-form-input id="vineyardNames" size="sm" v-model="vineyardNames"
                                placeholder="Vineyard Names"/>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Total Property Acres (for each non-contiguous parcel)*:"
                    label-for="totalPropertyAcres">
                  <b-form-input id="totalPropertyAcres" size="sm" v-model="totalPropertyAcres"
                                placeholder="Total Property Acres"/>
                </b-form-group>
                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Vineyard Acres (for each non-contiguous parcel)*:"
                    label-for="vineyardAcres">
                  <b-form-input id="vineyardAcres" size="sm" v-model="vineyardAcres"
                                placeholder="Vineyard Acres"/>
                </b-form-group>
                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Varieties Planted:"
                    label-for="varietiesPlanted">
                  <b-form-input id="varietiesPlanted" size="sm" v-model="varietiesPlanted"
                                placeholder="Varieties Planted"/>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Age Of Vines:"
                    label-for="ageOfVines">
                  <b-form-input id="ageOfVines" size="sm" v-model="ageOfVines"
                                placeholder="Age of Vines"/>
                </b-form-group>


                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="Are you planning a vineyard replant or new development within the next three years?:"
                    label-for="imminentPlanting">
                  <b-form-radio-group
                      id="imminentPlanting"
                      v-model="imminentPlanting"
                      :options="yesNoOptions"
                      name="waterMeterTracking"
                      stacked
                  />
                </b-form-group>


                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="When was your last Irrigation Distribution Uniformity Assessment?:"
                    label-for="input-sm">
                  <datepicker v-model="lastIDUAssessment" name="lastIDUDatePicker"
                              style="width: 80%" placeholder="Last Irrigation Distribution Uniformity Assessment Date"/>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="4"
                    label-size="md"
                    label="When did you last conduct soil testing?:"
                    label-for="lastSoilDatePicker">
                  <datepicker v-model="lastSoilTesting" name="lastSoilDatePicker"
                              style="width: 80%" placeholder="Last Soil Testing"/>
                </b-form-group>

                <b-container fluid="md">

                  <b-form-group label="Indicate current certifications (Check Relevant):">
                    <b-form-checkbox-group
                        v-model="vineyardCertifications"
                        :options="certificationsOptions"
                        name="renewableEnergyInstalled"
                        stacked
                    />
                  </b-form-group>

                  <b-form-group label="Indicate current practices (Check Relevant):">
                    <b-form-checkbox-group
                        v-model="practices"
                        :options="practicesOptions"
                        name="renewableEnergyInstalled"
                        stacked
                    />
                  </b-form-group>

                </b-container>

                <div class="button-holder">
                  <b-row align-h="center">
                    <b-col cols="2"/>
                    <b-col cols="8">*Questions marked with an asterisk must be completed to submit the
                      form.
                    </b-col>
                    <b-col cols="2"/>
                  </b-row>
                </div>
              </b-card>
            </b-container>
          </b-container>
          <b-container fluid>
            <b-row align-h="center">
              <b-col cols="2">
                <b-button id="submitButton" style="color: white; background-color: green"
                          class="submit-button"
                          type="submit" @click="submit('groupInfo')"
                          variant="primary" :disabled="!canSubmit">Submit
                </b-button>
              </b-col>
              <b-col cols="2">
                <b-button style="color: white; background-color: green" class="cancel-button"
                          type="cancel" @click="cancel"
                          variant="primary">Cancel
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-container>
    </b-container>

</template>

<script>
import VueInputUi from 'vue-input-ui';
import Datepicker from 'vuejs-datepicker';

const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

    export default {
      name: "AdminUpdateAccountInfo.vue",
      components: {
        VueInputUi,
        Datepicker
      },
      props: {
        groupId: String
      },
      data() {
        return {
          myGroupId: this.groupId || localStorage.getItem('adminImpersonationGroupId') || localStorage.getItem('groupId'),
          errors: [],
          alertsEnabled: "DISABLED",
          isSubmitted: true,
          contactPersonMap: [],
          county: null,
          countyMap: [{text: "", value: null},
                  {text: "Napa", value: "28"},
                  {text: "Lake", value: "17"},
                  {text: "Marin", value: "21"},
            {text: "Mendocino", value: "23"},
            {text: "Sonoma", value: "49"},
                  {text: "Solano", value: "48"}],
          primaryContactId: '',
          wineryName: {},
          businessName: '',
          businessAddress: '',
          requiredText: "*Required",
          primaryContact: '',
          contactTelephoneNumber: '',
          contactEmail: '',
          wasteProvider: '',
          waterSupplySource: '',
          wiesSelected: '',
          trackableWaterMeter: '',
                onSiteBottling: '',
                renewableEnergy: '',
                renewableEnergySelected: [],
          renewableEnergyOptions: ["Solar (at Winery)", "Solar (at Vineyard)", "Geothermal", "Wind", "Microturbine"],
          evChargingStations: '',
          environmentalCertifications: [],
          environmentalCertificationsOptions: ["CCSW", "LEED", "Organic", "Demeter Biodynamic"],
          yesNoOptions: ["Yes", "No"],
          statusOptions: ['ENABLED', 'DISABLED'],
          featuresSelected: [],
          featuresOptions: ["Barrel cellar", "Caves", "On Site Bottling", "Winery Tasting Room", "Offsite Tasting Room"
            , "Onsite Kitchen", "Barrel Cleaning Machine"],
          wasteWaterSelected: [],
          wasteWaterTreatmentOptions: ["Pond(s)", "Leach", "Packaged treatment system", "Hold and Haul"],
          entityType: '',
          ///////////////////////////
          // vineyard Properties   //
          name: '',
          address: '',
          contactName: '',
          contactTitle: '',
          ownerName: '',
          ownerEmail: '',
          ownerTelephoneNumber: '',
          vineyardNames: '',
          totalPropertyAcres: '',
          vineyardAcres: '',
          varietiesPlanted: '',
          ageOfVines: '',
          imminentPlanting: '',
          vineyardApns: '',
          lastIDUAssessment: '',
          lastSoilTesting: '',

          practices: [],
          practicesOptions: ["Have Carbon Farm Plan",
            "Compost",
            "Mulch",
            "Biochar",
            "Conservation tillage",
            "No-tillage",
            "Dry farming", "Livestock grazing",
            "Hedgerows", "Riparian/River/Ditch Restoration"],
          vineyardCertifications: [],
          certificationsOptions: ["CCSW", "Organic", "Demeter Biodynamic"],
          accountantName: '',
          accountantEmail: '',
          communicationsContact: ''
        }
        },
        computed: {
          displayWineryMenu: function () {
            console.log("Check entityType!");
            return this.entityType === "WINE";
          },
          computedEmail: function () {
            let self = this;
            if (this.contactPersonMap) {
              let contactInfo = this.contactPersonMap.find(function (val) {
                return val.value === self.primaryContactId;
              });
              return contactInfo ? contactInfo.email : "";
            }
            return "";
          },
          computedTelephone: function () {
            let self = this;
            if (this.contactPersonMap) {
              let contactInfo = this.contactPersonMap.find(function (val) {
                return val.value === self.primaryContactId;
              });
              return contactInfo ? contactInfo.phone : "";
            }
            return "";
          },
          validateBusinessName: function () {
            let isValid = this.businessName !== "Business Name" && this.businessName !== '';
            console.log("Business Name valid: " + isValid);
            return isValid;
          },
          validateBusinessAddress: function () {
            let isValid = this.businessAddress !== "Business Address" && this.businessAddress !== '';
            console.log("Business Name valid: " + isValid);
            return isValid;
          },
            validateContactName: function () {
                let isValid = this.primaryContact !== "Contact Name" && this.primaryContact !== '';
                console.log("Business Name valid: " + isValid);
                return isValid;
            },
            validateContactTelephoneNumber: function () {
                let isValid = this.contactTelephoneNumber !== "Telephone" && this.contactTelephoneNumber !== '';
                console.log("Business Name valid: " + isValid);
                return isValid;
            },
            validateContactEmail: function () {
                let isValid = this.validateEmailAddress(this.contactEmail);
                console.log("Email Address valid: " + isValid);
                return isValid;
            },
            canSubmit: function () {
              /*                return this.validateContactEmail && this.validateContactTelephoneNumber
                                  && this.validateContactName && this.validateBusinessAddress && this.validateBusinessName;
                                  &&*/
              // this.isFieldValid(this.accountantName, "Accountant Name")
              //  && this.validateEmailAddress(this.accountantEmail, "Accountant Name")
              //  && this.isFieldValid(this.communicationsContact, "Communications/Marketing Contact")
              //  && this.isFieldValid(this.ownerName, "Owner/Leadership Name")
              //  && this.isFieldValid(this.ownerEmail, "Owner/Leadership Email");
              return true;
            }
        },
        mounted() {
            this.loadAccountInfo(this);
        },
        methods:
            {
              getContactProperty: function (propertyName) {

                let self = this;
                if (this.contactPersonMap) {
                  let contactInfo = this.contactPersonMap.find(function (val) {
                    return val.value === self.primaryContactId;
                  });
                  return contactInfo ? contactInfo[propertyName] : "";
                }
                return "";

              },
              loadAccountInfo: function () {
                let self = this;
                this.$http.get("account/users/" + this.myGroupId)
                    .then(resp => {
                      console.log(resp.data);
                      let temp = resp.data;
                      let tempArray = [];
                      temp.forEach(function (obj) {
                        tempArray.push({text: obj.name, value: obj.id, phone: obj.telephone, email: obj.email});
                      })
                      this.contactPersonMap = tempArray;
                      console.log("Getting Options");
                    })
                this.$http.get("/groups/" + this.myGroupId)
                    .then(response => {
                      console.log("Group Info");
                      console.log(response.data);
                      let group = response.data;
                      this.alertsEnabled = group.alertsEnabled ? "ENABLED" : "DISABLED";
                      this.businessName = group.name;
                      this.businessAddress = group.address;
                      // this.primaryContact = group.primaryContact;
                      // this.contactTelephoneNumber = group.telephoneNumber;
                      // this.contactEmail = group.contactEmail;
                      this.ownerName = group.ownerName;
                      this.ownerTelephoneNumber = group.ownerTelephoneNumber;
                      this.ownerEmail = group.ownerEmail;
                      this.wasteProvider = group.wasteProvider;
                      this.waterSupplySource = group.waterSupplySource;
                      this.wiesSelected = group.wiesSelected;
                      this.trackableWaterMeter = group.trackableWaterMeter;
                      this.onSiteBottling = group.onSiteBottling;
                      this.renewableEnergy = group.renewableEnergy;
                      this.renewableEnergySelected = group.renewableEnergySelected || [];
                      this.evChargingStations = group.evChargingStations;
                      this.environmentalCertifications = group.environmentalCertifications || [];
                      this.featuresSelected = group.featuresSelected || [];
                      this.wasteWaterSelected = group.wasteWaterSelected || [];
                      this.primaryContactId = group.primaryContactId;
                      this.entityType = group.entityType;
                      this.name = group.name;
                      this.address = group.address;
                      this.ownerName = group.ownerName;
                      this.ownerEmail = group.ownerEmail;
                      this.ownerTelephoneNumber = group.ownerTelephoneNumber;
                      this.vineyardNames = group.vineyardNames;
                      this.totalPropertyAcres = group.totalPropertyAcres;
                      this.vineyardAcres = group.vineyardAcres;
                      this.varietiesPlanted = group.varietiesPlanted;
                      this.ageOfVines = group.ageOfVines;
                      this.imminentPlanting = group.imminentPlanting;
                      this.vineyardApns = group.vineyardApns;
                      this.lastIDUAssessment = group.lastIDUAssessment;
                      this.lastSoilTesting = group.lastSoilTesting;
                      this.practices = group.practices || [];
                      this.vineyardCertifications = group.vineyardCertifications || [];
                      this.county = group.county;
                      self.wineryName = this.businessName;
                      this.accountantName = group.accountantName;
                      this.accountantEmail = group.accountantEmail;
                      this.communicationsContact = group.communicationsContact;
                    })
                        .catch(function (error) {
                            self.$toasted
                                .show(`Failed To Load: ${error.message}`,
                                    {
                                        containerClass: 'super-toasty',
                                        iconPack: 'fontawesome',
                                        closeOnSwipe: true,
                                        action: {
                                            text: 'DISMISS',
                                            onClick: (e, toastObject) => {
                                                toastObject.goAway(0);
                                            }
                                        },
                                        icon: {
                                            name: 'fa-exclamation-triangle',
                                            after: false
                                        }
                                    })
                                .goAway(5000);
                        });
                },
                validateEmail: function (mail) {
                    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                        return true;
                    }
                    this.$vToastify.error('Form Validation Error',
                        `"You have entered an invalid email address!"`);
                    return false;
                },
                validateEmailAddress: function (email) {
                    return emailRegex.test(String(email).toLowerCase());
                },
                isFieldValid: function (fieldValue, defaultValue) {
                    return fieldValue !== defaultValue && fieldValue !== "";
                },
                validateForm: function (self, data) {
                  /*                    return self.validateEmailAddress(data.contactEmail)
                                          && self.isFieldValid(data.contactName, "Contact Name")
                                          && self.isFieldValid(data.contactTelephoneNumber, "Telephone")
                                          && self.isFieldValid(data.contactEmail, "Contact Email")
                                          && self.isFieldValid(data.businessName, "Business Name")
                                          && self.isFieldValid(data.businessAddress, "Business Address");*/
                  return true;
                },
                buildValidationMessage: function () {
                    return "Please enter a valid email address.";
                },
                buildGroupEntity: function () {
                  return this.entityType === "WINE" ? this.getWineryInfo() : this.getVineyardInfo();
                },
                submit: function (formName) {
                    let self = this;
                    let data;
                    let url = `groups/${self.myGroupId}/admin`;

                    data = this.buildGroupEntity();
                    this.$http.put(url, data, {
                        headers: {
                            'content-type': 'application/json'
                        }
                    })
                        .then(function (response) {
                            if (response.status === 202) {
                              self.$toasted.show("Group updated successfully.",
                                  {
                                    containerClass: 'super-toasty',
                                    iconPack: 'fontawesome',
                                    closeOnSwipe: true,
                                    action: {
                                      text: 'DISMISS',
                                      onClick: (e, toastObject) => {
                                        toastObject.goAway(0);
                                      }
                                    },
                                        icon: {
                                            name: 'fa-check-circle',
                                            after: false
                                        }
                                    })
                                    .goAway(5000);
                            }
                        })
                        .then(function () {
                            self.loadAccountInfo();
                        })
                        .catch(function (error) {
                            self.$toasted.show(`Group update failed with error: ${error.message}`,
                                {
                                    containerClass: 'super-toasty',
                                    iconPack: 'fontawesome',
                                    closeOnSwipe: true,
                                    action: {
                                        text: 'DISMISS',
                                        onClick: (e, toastObject) => {
                                            toastObject.goAway(0);
                                        }
                                    },
                                    icon: {
                                      name: 'fa-times-circle',
                                      after: false
                                    }
                                })
                                .goAway(5000);
                        });
                },
              cancel: function () {
                console.log("Canceling Update");
                this.$router.push({path: '/my-account'});
              },
              getVineyardInfo: function () {
                return {
                  _id: this.myGroupId,
                  alertsEnabled: this.alertsEnabled === "ENABLED",
                  name: this.name,
                  address: this.address,
                  primaryContact: this.getContactProperty("text"),
                  //contactTitle: this.contactTitle,
                  telephoneNumber: this.getContactProperty("phone"),
                  contactEmail: this.getContactProperty("email"),
                  ownerName: this.ownerName,
                  ownerEmail: this.ownerEmail,
                  ownerTelephoneNumber: this.ownerTelephoneNumber,
                  vineyardNames: this.vineyardNames,

                  totalPropertyAcres: this.totalPropertyAcres,
                  vineyardAcres: this.vineyardAcres,
                  varietiesPlanted: this.varietiesPlanted,
                  ageOfVines: this.ageOfVines,
                  imminentPlanting: this.imminentPlanting,
                  vineyardApns: this.vineyardApns,
                  lastIDUAssessment: this.lastIDUAssessment,
                  lastSoilTesting: this.lastSoilTesting,
                  vineyardCertifications: this.vineyardCertifications,
                  //entityType: "VINEYARD",
                  practices: this.practices,
                  certifications: this.certifications,
                  primaryContactId: this.primaryContactId,
                  county: this.county,
                  accountantName: this.accountantName,
                  accountantEmail: this.accountantEmail,
                  communicationsContact: this.communicationsContact
                };
              },
              getWineryInfo: function () {
                let self = this;
                return {
                  _id: self.myGroupId,
                  alertsEnabled: this.alertsEnabled === "ENABLED",
                  name: self.businessName,
                  address: self.businessAddress,
                  primaryContact: self.getContactProperty("text"),
                  telephoneNumber: self.getContactProperty("phone"),
                  contactEmail: self.getContactProperty("email"),
                  ownerName: self.ownerName,
                  ownerTelephoneNumber: self.ownerTelephoneNumber,
                  ownerEmail: self.ownerEmail,
                  wasteProvider: self.wasteProvider,
                  waterSupplySource: self.waterSupplySource,
                  wiesSelected: self.wiesSelected,
                  trackableWaterMeter: self.trackableWaterMeter,
                  onSiteBottling: self.onSiteBottling,
                  renewableEnergy: self.renewableEnergy,
                  renewableEnergySelected: self.renewableEnergySelected,
                  environmentalCertifications: self.environmentalCertifications,
                  featuresSelected: self.featuresSelected,
                  wasteWaterSelected: self.wasteWaterSelected,
                  evChargingStations: self.evChargingStations,
                  primaryContactId: self.primaryContactId,
                  county: self.county,
                  accountantName: self.accountantName,
                  accountantEmail: self.accountantEmail,
                  communicationsContact: self.communicationsContact
                };
              },
            }
    }
</script>

<style scoped>
    .cancel-button {
        margin-left: 10px;
        margin-top: 5px;
    }

    .submit-button {
        margin-left: 10px;
        margin-top: 5px;
    }

    .button-holder {
        horiz-align: center;
        display: flex; /*Requires vendor prefixes*/
        justify-content: center; /*Requires vendor prefixes*/
        align-items: center; /*Requires vendor prefixes*/
    }
</style>
